import { DocumentServicesObject } from '@wix/document-services-types';
import { ElementData } from '@wix/editor-platform-sdk-types';

import { PrimaryConnectionsWithRefs } from '@wix/editor-platform-host-integration-apis';
import { getCompRefForNormalizedItem } from './compRefUtils';

export const getFullNormalizedItem = (
  documentServicesAPI: DocumentServicesObject,
  primaryConnectionsWithRefs: PrimaryConnectionsWithRefs[],
  item: ElementData,
) => {
  const compRef = getCompRefForNormalizedItem(
    documentServicesAPI,
    item.identifier,
    primaryConnectionsWithRefs,
  );

  if (!compRef) {
    return item;
  }

  const properties = documentServicesAPI.components.properties.get(compRef);
  const compBehavior =
    documentServicesAPI.platform.controllers.getConnectedComponentStageData(
      compRef,
      // @ts-expect-error
    )?.behavior;

  return {
    ...item,

    // TODO: provide editorAPI.components.getDisplayName from santa and use if there are no item.label
    displayName: item.label,
    compRef,
    isCollapsed: properties?.ghost === 'COLLAPSED',
    isNonRemovable: compBehavior?.preventHide,
  };
};
